export const traderQueryKeys = {
  all: ['/v3/trader'] as const,
  page: (name: string, page: number, size: number) => [...traderQueryKeys.all, 'page', name, page, size] as const,
}

export default traderQueryKeys
